import { DocumentModel } from "./document.model";

export class MongoVideoModel extends DocumentModel {
    constructor(
        private created?: string,
        private fileName?: string
    ){
      super();
    }

    setCreated(created?: string): void {
      this.created = created ? created: null;
      return;
    }

    getCreated(): string {
      return this.created;
    }

    setFileName(fileName: string): void {
      this.fileName = fileName ? fileName : null ;
      return;
    }

    getFileName(): string {
      return this.fileName;
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/models/mongoVideo.model.ts